import moment from "moment/moment";
import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import EditIcon from "../../images/edit.svg";
import DeleteIcon from "../../images/delete.svg";
import InactiveIcon from "../../images/inactive.svg";
import { getNameFromSettings } from "../../helpers/utils";
import {
  SETTINGS_APPROVAL_TIME_LIST,
  SETTINGS_LTV_LIST,
  IMAGE_BASE_URL
} from "../../helpers/constants";
import { FaCrown } from "react-icons/fa";
import { AiFillStar } from "react-icons/ai";
import {
  Menu,
  MenuItem,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import MoreIcon from "../../images/more-horizontal.png";

const BankCard = (props) => {
  const {
    onFeatureClick,
    product,
    interestSort: InterestIndex,
    onInactiveClick,
    onDeleteClick,
    onEditClick,
    handleCloseMenu,
    handleOpenMenu,
    menuOpen,
    anchorEl,
    index,
    pagePermission,
    activeTab,
    allAgentBonus, 
    expandedRemarksIndex,
  setExpandedRemarksIndex,
  } = props;

  const Interest = product?.interests?.find(
    (item) => item.id === product?.activeinterest?.id
  );

  // const [showAllRemarks, setShowAllRemarks] = useState(false);
  // const [expandedRemarksIndex, setExpandedRemarksIndex] = useState(null);

  const isExpanded = expandedRemarksIndex === index;
 

  const settings = useSelector((state) => state.settings);

  let startDate = Interest?.startDate
    ? moment(Interest?.startDate).format("DD MMM YYYY").toUpperCase()
    : null;
  let endDate = Interest?.endDate
    ? moment(Interest?.endDate).format("DD MMM YYYY").toUpperCase()
    : null;

  const handleAgentBonus = (e) => {
    e.preventDefault();
    const agentData = {
      name: product.name,
      icon: product.icon,
      startDate,
      endDate,
      interest: Interest?.interest,
    };
    if (product?.bonuses && product?.bonuses.length > 0) {
      allAgentBonus(agentData, product?.bonuses);
    }
  };

  return (
    <ThemeProvider theme={createTheme()}>
      <div className={`bank-card-item rounded-[16px] bg-white pt-0 pb-[0px] px-[20px] w-[32%] max-[1300px]:w-[48%] max-[700px]:w-[100%] max-w-[100%] cus_shadow2 relative m-[20px_9px_40px_9px]  ${isExpanded ? "z-[9]" : "z-0"
        }`} >
        <div className="back-card-expand rounded-[16px] shadow-[0_4px_30px_rgba(0,0,0,0.1)] border border-[#e0e0e0]">
          <div className="absolute top-[-19px] right-[30px] p-[2px_8px] text-white text-[10px] rounded-[4px_4px_0_0] z-[-1]"
            style={{ backgroundColor: product?.cardheadercolor }}>
            {product?.cardheadertext}
          </div>

          <div className="relative bg-white flex items-start">
            <div className="absolute top-[-40px] bg-white h-[58px] w-[58px] rounded-lg shadow-sm">
              <img
                src={`${IMAGE_BASE_URL}/${product.icon}`}
                alt="Bank Logo"
                className="rounded-lg w-full h-full object-contain"
              />
            </div>

            <div className="pl-[70px] flex-1">
              <div className="flex justify-between items-start">
                <span className="font-[700] text-[15px] text-gray-800 line-clamp-1">
                  {product.name}
                </span>
                <div className="text-left">
                  <div className="text-[22px] font-bold text-black leading-tight">
                    {Interest?.interest}%
                  </div>
                  <div
                    className={`text-[13px] text-[#0F59F9] w-[60px] ${product?.totalBonuses > 0 ? "cursor-pointer" : "cursor-default"}`}
                    onClick={handleAgentBonus}
                  >
                    Bonus ({product?.totalBonuses})
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <img
                src={MoreIcon}
                className="w-5 cursor-pointer"
                onClick={(e) => handleOpenMenu(index, e)}
                id="fade-button"
              />
              {pagePermission?.update_permission == 1 && (
                <Menu
                  id="fade-button"
                  anchorEl={anchorEl}
                  open={menuOpen}
                  onClose={handleCloseMenu}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.1))",
                      mt: 1,
                      minWidth: "140px",
                      "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  <MenuItem onClick={() => { handleCloseMenu(false); onEditClick(product); }}>
                    <img src={EditIcon} className="h-4 w-4 mr-4" /> Edit Product
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleCloseMenu();
                      onInactiveClick(product.id, product.inactive);
                    }}
                    disabled={product?.isExpired == 1}
                    sx={{
                      opacity: product?.isExpired !== 1 ? 1 : "0.5",
                    }}
                  >
                    <img src={InactiveIcon} className="h-4 w-4 mr-4" />
                    {product.status ? "Inactive" : "Active"}
                  </MenuItem>
                  {Object.keys(activeTab).length > 0 &&
                    activeTab.parameter == "status" &&
                    activeTab.value == 0 && (
                      <MenuItem
                        onClick={() => {
                          handleCloseMenu();
                          onDeleteClick(product.id);
                        }}
                      >
                        <img src={DeleteIcon} className="h-4 w-4 mr-4" />
                        Delete
                      </MenuItem>
                    )}
                </Menu>
              )}
            </div>
          </div>
            <div className="flex items-center gap-x-2 premiumtag">
              {product?.hasPremium == 1 && (
                <div className="inline-flex items-center mb-[8px] p-[1px] px-2 text-[10px] border rounded-[4px]">
                  <FaCrown size={23} color="#ffac04" className="pe-2" />
                  <p>Premium</p>
                </div>
              )}
              {product?.featured == 1 && (
                <div
                  onClick={() => onFeatureClick(product.id, product.featured)}
                  className="inline-flex items-center mb-[8px] p-[1px] px-2 text-[10px] border rounded-[4px] cursor-pointer"
                >
                  <AiFillStar
                    size={23}
                    color={product.featured ? "#ffac04" : "#d3d3d3"}
                    className="pe-2"
                  />
                  <p>Featured</p>
                </div>
              )}
            </div>
          <div className="flex flex-wrap gap-[5px] mb-[10px] cardstandardheight">


            <div className="w-full text-[13px] text-[#333]">
              {Array.isArray(Interest?.remarks) && (
                <>
                  <ul className="list-disc pl-4 space-y-[4px] m-0 transition-all duration-300 ease-in-out">
                    {(isExpanded ? Interest.remarks : Interest.remarks.slice(0, 3)).map((item, idx) => (
                      <li key={idx} className="text-[12px] text-black leading-[1.4]">
                        <span
                          className={`block ${!isExpanded ? "truncate overflow-hidden whitespace-nowrap text-ellipsis" : ""}`}
                          title={item?.text || ""}
                        >
                          {item?.text || ""}
                        </span>
                      </li>
                    ))}
                  </ul>

                  {Interest.remarks.length > 3 && (
                    <div className="text-center">
                      {/* <span
                        onClick={() => setShowAllRemarks((prev) => !prev)}
                        className="text-blue-600 mt-1 inline-block cursor-pointer text-[13px] font-bold"
                      >
                        {showAllRemarks ? "Read less" : "See more"}
                      </span> */}

                      <span
                        onClick={() =>
                          setExpandedRemarksIndex(isExpanded ? null : index)
                        }
                        className="text-blue-600 mt-1 inline-block cursor-pointer text-[13px] font-bold"
                      >
                        {isExpanded ? "See less" : "See more"}
                      </span>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          <p className="text-[12px] mb-1 flex items-center">
            <img src="/images/fi_dollar.svg" className="mr-[5px]" />
            Min. Loan:
            <strong className="ml-[5px] font-[600]">
              {Interest?.minimum_loan_amount > 0
                ? "$" + parseInt(Interest?.minimum_loan_amount)
                : "No min. loan required"}{" "}
              {Interest?.admin_fee_status === "1" &&
                `else + admin fee $${parseInt(Interest?.admin_fee)}`}
            </strong>
          </p>

          <p className="text-[12px] mb-1 flex items-center">
            <img src="/images/fi_calendar.svg" className="mr-[5px]" />
            Available from:
            <strong className={`ml-[5px] font-[600] ${product.isExpired == 1 ? "text-red-600" : ""}`}>
              {startDate}
            </strong>
            <span className="mx-[6px]">to</span>
            <strong className={`font-[600] ${product.isExpired == 1 && endDate ? "text-red-600" : ""}`}>
              {endDate ? endDate : "Further Notice"}
            </strong>
          </p>

          <div className="flex flex-wrap items-center justify-between gap-[5px_10px]">
            <p className="text-[12px] flex items-center">
              <img src="/images/fi_clock.svg" className="mr-[5px]" />
              Approval time:
              <strong className="ml-[5px] font-[600]">
                {getNameFromSettings(settings, SETTINGS_APPROVAL_TIME_LIST, product.approvalTime)}
              </strong>
            </p>
            <p className="text-[12px] flex items-center">
              <img src="/images/fi_zap.svg" className="mr-[5px]" />
              Loan to Value:
              <strong className="ml-[5px] font-[600]">
                {getNameFromSettings(settings, SETTINGS_LTV_LIST, product.ltv)}
              </strong>
            </p>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default BankCard;
